<section class="maintenance-page">
  <header class="maintenance-header">
    <div>
      <h1>Maintenance</h1>
      @if (etat.parcSelectionne()) {
        <p class="maintenance-subtitle">Parc {{ etat.parcSelectionne()!.libelle }}</p>
      }
    </div>
    <app-intervention-acces [installationsDisponibles]="etat.installations()" />
    <div class="maintenance-type-filters" role="group" aria-label="Type d’intervention">
      @for (filtre of filtresTypes(); track filtre.value) {
        <button
          type="button"
          class="maintenance-filter-btn"
          [class.is-active]="filtreType() === filtre.value"
          [attr.aria-pressed]="filtreType() === filtre.value"
          (click)="changerFiltreType(filtre.value)"
        >
          {{ filtre.label }} <span>{{ filtre.count }}</span>
        </button>
      }
    </div>
  </header>

  <div
    class="maintenance-layout"
    [class.sans-agenda]="!jourSelectionne() && !afficherProchainesInterventions()"
    [attr.aria-busy]="chargementInterventions()"
  >
    @if (chargementInterventions()) {
      <app-spinner-overlay
        style="position: absolute; inset: 0; z-index: 20"
        [visible]="true"
        [label]="'Chargement des interventions de ' + periodeLabel() + '…'"
      />
    }
    <section
      class="maintenance-panel maintenance-panel-center"
      [class.maintenance-panel-month]="modeVue() === 'mois'"
    >
      <div class="maintenance-calendar-header">
        <h2>{{ periodeLabel() }}</h2>

        <div class="maintenance-calendar-toolbar">
          <div class="maintenance-view-selector" role="group" aria-label="Vue du calendrier">
            <button
              type="button"
              [class.is-active]="modeVue() === 'mois'"
              [attr.aria-pressed]="modeVue() === 'mois'"
              (click)="changerModeVue('mois')"
            >
              Mensuelle
            </button>
            <button
              type="button"
              [class.is-active]="modeVue() === 'annee'"
              [attr.aria-pressed]="modeVue() === 'annee'"
              (click)="changerModeVue('annee')"
            >
              Annuelle
            </button>
          </div>
          <button
            type="button"
            class="maintenance-nav-btn"
            [attr.aria-label]="modeVue() === 'annee' ? 'Année précédente' : 'Mois précédent'"
            (click)="changeMonth(-1)"
          >
            <span class="material-symbols-outlined">chevron_left</span>
          </button>
          <button type="button" class="maintenance-today-btn" (click)="resetToday()">
            Aujourd'hui
          </button>
          <button
            type="button"
            class="maintenance-nav-btn"
            [attr.aria-label]="modeVue() === 'annee' ? 'Année suivante' : 'Mois suivant'"
            (click)="changeMonth(1)"
          >
            <span class="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
      </div>

      <div class="maintenance-legend" role="group" aria-label="Légende des interventions">
        <span class="maintenance-legend-title">Légende</span>
        <span class="maintenance-legend-item">
          <span
            class="maintenance-legend-swatch"
            [style.background]="couleursInterventions.intervention_preventive"
            aria-hidden="true"
          ></span>
          Préventives
        </span>
        <span class="maintenance-legend-item">
          <span
            class="maintenance-legend-swatch"
            [style.background]="couleursInterventions.intervention_curative"
            aria-hidden="true"
          ></span>
          Curatives
        </span>
      </div>

      @if (chargementInterventions()) {
        <p class="maintenance-feedback">Chargement des interventions...</p>
      } @else if (erreurInterventions()) {
        <p class="maintenance-feedback maintenance-feedback-error">{{ erreurInterventions() }}</p>
      } @else if (interventionsAffichees().length === 0) {
        <p class="maintenance-feedback">
          {{
            filtreType() === 'intervention_preventive'
              ? 'Aucune intervention préventive sur '
              : filtreType() === 'intervention_curative'
                ? 'Aucune intervention curative sur '
                : 'Aucune intervention sur '
          }}{{ periodeTexte() }}.
        </p>
      }

      @if (modeVue() === 'annee') {
        <div class="maintenance-year-grid">
          @for (mois of moisAnnee(); track mois.index) {
            <section class="maintenance-year-month">
              <button
                type="button"
                class="maintenance-year-month-heading"
                (click)="ouvrirMois(mois.index)"
                [attr.aria-label]="'Ouvrir ' + mois.label + ' ' + periodeLabel()"
              >
                <strong>{{ mois.label }}</strong>
                <span>{{ mois.nombre }} intervention{{ mois.nombre > 1 ? 's' : '' }}</span>
              </button>
              <div class="maintenance-mini-calendar">
                @for (jour of weekdays; track jour) {
                  <span class="maintenance-mini-weekday" [attr.title]="jour">{{
                    jour.slice(0, 1)
                  }}</span>
                }
                @for (cell of mois.cellules; track cell.iso) {
                  @if (cell.isCurrentMonth) {
                    <button
                      type="button"
                      class="maintenance-mini-day"
                      [class.is-today]="cell.isToday"
                      [style.background]="couleurJour(cell)"
                      [attr.aria-label]="libelleJour(cell)"
                      [attr.title]="libelleJour(cell)"
                      [attr.data-jour-creation]="cell.iso"
                      [disabled]="!peutCreerIntervention()"
                      [matMenuTriggerFor]="menuCreation"
                      [matMenuTriggerData]="{ jour: cell.iso }"
                      (pointerdown)="focaliserJour($event)"
                      (menuOpened)="preparerMenuJour(cell.iso)"
                      (menuClosed)="jourCreation.set(null)"
                    >
                      {{ cell.day }}
                    </button>
                  } @else {
                    <span aria-hidden="true"></span>
                  }
                }
              </div>
            </section>
          }
        </div>
      } @else {
        <div class="maintenance-weekdays">
          @for (day of weekdays; track day) {
            <div class="maintenance-weekday">{{ day }}</div>
          }
        </div>

        <div class="maintenance-calendar-grid">
          @for (cell of calendarCells(); track trackCell($index, cell)) {
            <div
              class="maintenance-calendar-cell"
              [class.is-outside]="!cell.isCurrentMonth"
              [class.is-menu-open]="jourCreation() === cell.iso"
            >
              <button
                type="button"
                class="maintenance-calendar-day"
                [attr.aria-label]="libelleJour(cell)"
                [attr.data-jour-creation]="cell.iso"
                [disabled]="!peutCreerIntervention()"
                [matMenuTriggerFor]="menuCreation"
                [matMenuTriggerData]="{ jour: cell.iso }"
                (pointerdown)="focaliserJour($event)"
                (menuOpened)="preparerMenuJour(cell.iso)"
                (menuClosed)="jourCreation.set(null)"
              >
                <span class="maintenance-calendar-day-number" [class.is-today]="cell.isToday">{{
                  cell.day
                }}</span>
              </button>

              <div class="maintenance-calendar-events">
                @for (
                  item of cell.interventions.slice(0, 3);
                  track trackIntervention($index, item)
                ) {
                  <button
                    type="button"
                    class="maintenance-calendar-event"
                    [class.is-selected]="isSelectedIntervention(item)"
                    [style.background]="item.color"
                    (click)="ouvrirInterventionModal(item, $event)"
                  >
                    {{ installationLabel(item) }} - {{ item.site }}
                  </button>
                }
                @if (cell.interventions.length > 3) {
                  <button
                    type="button"
                    class="maintenance-calendar-more"
                    [attr.aria-label]="
                      'Voir les ' + cell.interventions.length + ' interventions du ' + cell.day
                    "
                    [attr.aria-expanded]="jourSelectionne() === cell.iso"
                    (click)="ouvrirJournee(cell, $event)"
                  >
                    +{{ cell.interventions.length - 3 }} autre{{
                      cell.interventions.length > 4 ? 's' : ''
                    }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
      <mat-menu #menuCreation="matMenu" class="maintenance-day-menu" [overlapTrigger]="false">
        <ng-template matMenuContent let-jour="jour">
          @if (peutPlanifier()) {
            <button
              mat-menu-item
              [disabled]="jour < dateMinPlanification()"
              (click)="creerDepuisJour(jour, 'planification', 'curative')"
            >
              <span class="material-symbols-outlined" aria-hidden="true">event_note</span>
              <span>Planification d’intervention curative</span>
            </button>
          }
          @if (peutCreerBon()) {
            <button mat-menu-item (click)="creerDepuisJour(jour, 'bon')">
              <span class="material-symbols-outlined" aria-hidden="true">description</span>
              <span>Bon d’intervention curatif</span>
            </button>
          }
          @if (peutPlanifier()) {
            <button
              mat-menu-item
              [disabled]="jour < dateMinPlanification()"
              (click)="creerDepuisJour(jour, 'planification', 'preventive')"
            >
              <span class="material-symbols-outlined" aria-hidden="true">event_available</span>
              <span>Planification d’intervention préventive</span>
            </button>
            @if (jour < dateMinPlanification()) {
              <p class="maintenance-day-menu-help">
                La planification est disponible à partir d’aujourd’hui.
              </p>
            }
          }
        </ng-template>
      </mat-menu>
    </section>

    @if (jourSelectionne()) {
      <app-maintenance-day-panel
        [dateLabel]="jourSelectionneLabel()"
        [interventions]="interventionsJournee()"
        (fermer)="fermerJournee()"
        (ouvrirIntervention)="ouvrirInterventionJournee($event)"
      />
    } @else if (afficherProchainesInterventions()) {
      <app-prochaines-interventions
        [items]="interventionsAffichees()"
        [month]="displayedMonth()"
        [loading]="chargementInterventions()"
        [error]="erreurInterventions()"
        [(selectedKey)]="selectedInterventionId"
      />
    }
  </div>
</section>

@if (interventionModalData(); as modal) {
  <app-intervention-modal [data]="modal" (fermer)="fermerInterventionModal()" />
}
